export function constructUrl(_ref) {
  var videoId = _ref.videoId,
    controls = _ref.controls,
    mute = _ref.mute,
    autoplay = _ref.autoplay;
  var baseUrl = 'https://player.vimeo.com/video/';
  var searchParams = {};
  if (controls) {
    // Controls must be enabled in order to control mute and autoplay
    // `background` sets these automatically
    searchParams = {
      controls: controls ? '1' : '0',
      muted: mute ? '1' : '0',
      autoplay: autoplay ? '1' : '0'
    };
  } else {
    searchParams = {
      background: '1'
    };
  }
  var params = new URLSearchParams(searchParams);
  return "".concat(baseUrl).concat(videoId, "?").concat(params.toString());
}